// extracted by mini-css-extract-plugin
export default {"container":"CentralDeMonitoramento_container__Q4FQT"};